import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class SimDynamicScriptService {
	private static readonly loadPromises: {[path: string]: Promise<void>} = {};

	constructor() {}

	public loadScript(scriptPath: string, assetRoot: string = environment.baseHref + "/assets/js/"): Promise<void> {
		let fullPath = (assetRoot ?? "") + scriptPath;
		let scripts = document.getElementsByTagName("script");
		for (let i = 0; i < scripts.length; ++i) {
			if (scripts[i].getAttribute("src") == fullPath) {
				return SimDynamicScriptService.loadPromises[fullPath] ?? Promise.resolve();
			}
		}

		let node = document.createElement("script");
		node.src = fullPath;
		node.type = "text/javascript";
		node.async = true;

		let scriptTag = document.getElementsByTagName("head")[0].appendChild(node);
		let promise = new Promise<void>((resolve, reject) => {
			scriptTag.onload = () => resolve();
			scriptTag.onerror = () => reject();
		});

		SimDynamicScriptService.loadPromises[fullPath] = promise;
		return promise;
	}
}
